import { useCallback } from "react";

import { Router } from "@utils";
import { toastify } from "@vendors";
import { useAsyncRequest } from "@hooks";

import ActionMenuBaseItem from "@components/action_menu/item_types/ActionMenuBaseItem";

export default function ActionMenuDuplicateRecordItem(props) {
  const {
    record,
    confirmationMessage = "Are you sure you want to duplicate?",
    onDuplicateSuccessMessage = "Record duplication succeeded!",
    onDuplicateFailureMessage = "Record duplication failed!",
  } = props;

  const handleExecuteDuplicationSuccess = useCallback((data) => {
    const duplicateRecord = data?.records;

    if (duplicateRecord.id) {
      toastify.onReload({ type: "success", value: onDuplicateSuccessMessage });
      Router.redirectToPath(`/${record.type}/${duplicateRecord.id}`);
    } else {
      toastify.onReload({ type: "error", value: onDuplicateFailureMessage });
      Router.redirectToPath(`/${record.type}`);
    }
  }, [onDuplicateSuccessMessage, onDuplicateFailureMessage, record.type]);

  const handleExecuteDuplicationFailure = useCallback((error) => {
    toastify.error("Error!");

    console.error(error);
  }, []);

  const executeDuplication = useAsyncRequest({
    path: `/${record.type}/${record.id}/duplicate`,
    method: "POST",
    onSuccess: handleExecuteDuplicationSuccess,
    onFailure: handleExecuteDuplicationFailure,
  });

  const handleClick = useCallback((event) => {
    event.keepOpen = true;

    if (window.confirm(confirmationMessage)) {
      executeDuplication();
    }
  }, [confirmationMessage, executeDuplication]);

  /**************************************************************************************************/

  return (
    <ActionMenuBaseItem
      onClick={handleClick}
      label={{
        text: "Duplicate",
        icon: "clone",
      }}
      {...props}
    />
  );
}
